import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Button,
  Row,
  Col,
  Table,
  Modal,
  Spinner,
  Badge,
  InputGroup,
} from "react-bootstrap";
import Layout from "../../layout/Layout";
import { useAuth } from "../../context/AuthContext";
import * as XLSX from "xlsx";

import {
  uploadRuloFormat,
  sendStockMailFormat,
  getCustomerMailList,
  createCustomerMail,
  updateCustomerMail,
  deleteCustomerMail,
} from "../../../api/seller/stockCustomerApi";

function RuloStokSatisGiris() {
  const { user } = useAuth();

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mailSending, setMailSending] = useState(false);
  const [resData, setResData] = useState(null);

  const [showMailModal, setShowMailModal] = useState(false);
  const [mailListLoading, setMailListLoading] = useState(false);
  const [mailList, setMailList] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [sendResultMap, setSendResultMap] = useState({});

  const [mailSearch, setMailSearch] = useState("");
  const [mailFormMode, setMailFormMode] = useState("create");
  const [editingMailId, setEditingMailId] = useState(null);

  const [mailForm, setMailForm] = useState({
    companyName: "",
    contactName: "",
    email: "",
    phone: "",
    department: "",
    tagsText: "rulo-stok",
    mailPermission: true,
    note: "",
    source: "manual",
  });

  const [feedback, setFeedback] = useState({
    show: false,
    type: "success",
    message: "",
  });

  const turIsimleri = {
    CR: "Soguk",
    GR: "Galvaniz",
    HR: "Sıcak",
  };

  const showFeedback = (type, message) => {
    setFeedback({
      show: true,
      type,
      message,
    });
  };

  const resetMailForm = () => {
    setMailFormMode("create");
    setEditingMailId(null);
    setMailForm({
      companyName: "",
      contactName: "",
      email: "",
      phone: "",
      department: "",
      tagsText: "rulo-stok",
      mailPermission: true,
      note: "",
      source: "manual",
    });
  };

  const closeMailModal = () => {
    setShowMailModal(false);
    setSendResultMap({});
  };

  const loadCustomerMails = async () => {
    setMailListLoading(true);

    try {
      const response = await getCustomerMailList({
        search: mailSearch,
        page: 1,
        limit: 500,
      });

      const list = response?.data?.data || [];
      setMailList(list);

      const activeSelected = list
        .filter((item) => item.mailPermission !== false)
        .map((item) => item.email);

      setSelectedEmails(activeSelected);
    } catch (err) {
      console.error("Mail listesi alinamadi:", err);
      showFeedback("danger", "Mail listesi alinirken hata olustu.");
    } finally {
      setMailListLoading(false);
    }
  };

  useEffect(() => {
    if (showMailModal) {
      loadCustomerMails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMailModal]);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!user) {
      showFeedback("danger", "Oturumunuz kapali veya yetkisiz giris.");
      return;
    }

    if (!file) {
      showFeedback("danger", "Lutfen once bir Excel dosyasi secin.");
      return;
    }

    setLoading(true);

    try {
      const userId = user._id || user.id;
      const response = await uploadRuloFormat(userId, file);

      if (response.data && response.data.success) {
        setResData(response.data);
        showFeedback("success", "Dosya basariyla islendi ve veriler alindi.");
      } else {
        showFeedback("danger", "Dosya islenirken bir hata olustu.");
      }
    } catch (err) {
      console.error("Yukleme hatasi:", err);
      showFeedback(
        "danger",
        "Sunucuya baglanirken bir hata olustu veya hatali format."
      );
    } finally {
      setLoading(false);
    }
  };

  let crTotalKg = 0;
  let grTotalKg = 0;
  let hrTotalKg = 0;

  const crItems = resData?.data?.CR || [];
  const grItems = resData?.data?.GR || [];
  const hrItems = resData?.data?.HR || [];

  if (resData && resData.data) {
    if (resData.data.CR) {
      crTotalKg = resData.data.CR.reduce(
        (sum, item) => sum + Number(item.KG || 0),
        0
      );
    }

    if (resData.data.GR) {
      grTotalKg = resData.data.GR.reduce(
        (sum, item) => sum + Number(item.KG || 0),
        0
      );
    }

    if (resData.data.HR) {
      hrTotalKg = resData.data.HR.reduce(
        (sum, item) => sum + Number(item.KG || 0),
        0
      );
    }
  }

  const genelTotalKg = crTotalKg + grTotalKg + hrTotalKg;

  const allEbatSet = new Set();
  const crKalinlikSet = new Set();
  const grKalinlikSet = new Set();
  const hrKalinlikSet = new Set();

  crItems.forEach((i) => {
    allEbatSet.add(i.EBAT || "-");
    crKalinlikSet.add(i.KALINLIK || 0);
  });

  grItems.forEach((i) => {
    allEbatSet.add(i.EBAT || "-");
    grKalinlikSet.add(i.KALINLIK || 0);
  });

  hrItems.forEach((i) => {
    allEbatSet.add(i.EBAT || "-");
    hrKalinlikSet.add(i.KALINLIK || 0);
  });

  const sortedEbatlar = Array.from(allEbatSet).sort((a, b) =>
    a.localeCompare(b, undefined, { numeric: true })
  );

  const crKalinliklar = Array.from(crKalinlikSet).sort((a, b) => a - b);
  const grKalinliklar = Array.from(grKalinlikSet).sort((a, b) => a - b);
  const hrKalinliklar = Array.from(hrKalinlikSet).sort((a, b) => a - b);

  const handleRemoveItem = (groupKey, itemIndex) => {
    setResData((prev) => {
      const newData = { ...prev.data };
      const updatedArray = [...newData[groupKey]];

      updatedArray.splice(itemIndex, 1);

      if (updatedArray.length === 0) {
        delete newData[groupKey];
      } else {
        newData[groupKey] = updatedArray;
      }

      return { ...prev, data: newData };
    });
  };

  const handleRemoveFromMatrix = (turKodu, ebat, kalinlik) => {
    setResData((prev) => {
      const newData = { ...prev.data };

      if (!newData[turKodu]) return prev;

      const filteredArray = newData[turKodu].filter(
        (item) =>
          !((item.EBAT || "-") === ebat && (item.KALINLIK || 0) === kalinlik)
      );

      if (filteredArray.length === 0) {
        delete newData[turKodu];
      } else {
        newData[turKodu] = filteredArray;
      }

      return { ...prev, data: newData };
    });
  };

  const handleToggleEmail = (email) => {
    setSelectedEmails((prev) => {
      if (prev.includes(email)) {
        return prev.filter((item) => item !== email);
      }

      return [...prev, email];
    });
  };

  const handleToggleAllEmails = () => {
    const permissionEmails = mailList
      .filter((item) => item.mailPermission !== false)
      .map((item) => item.email);

    if (selectedEmails.length === permissionEmails.length) {
      setSelectedEmails([]);
    } else {
      setSelectedEmails(permissionEmails);
    }
  };

  const handleEditMail = (item) => {
    setMailFormMode("update");
    setEditingMailId(item._id);

    setMailForm({
      companyName: item.companyName || "",
      contactName: item.contactName || "",
      email: item.email || "",
      phone: item.phone || "",
      department: item.department || "",
      tagsText: Array.isArray(item.tags) ? item.tags.join(", ") : "",
      mailPermission: item.mailPermission !== false,
      note: item.note || "",
      source: item.source || "manual",
    });
  };

  const handleSaveMail = async () => {
    if (!mailForm.email) {
      showFeedback("danger", "Mail adresi zorunludur.");
      return;
    }

    const payload = {
      companyName: mailForm.companyName,
      contactName: mailForm.contactName,
      email: mailForm.email,
      phone: mailForm.phone,
      department: mailForm.department,
      tags: mailForm.tagsText
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean),
      mailPermission: mailForm.mailPermission,
      note: mailForm.note,
      source: mailForm.source || "manual",
    };

    try {
      if (mailFormMode === "update" && editingMailId) {
        await updateCustomerMail(editingMailId, payload);
        showFeedback("success", "Mail kaydi guncellendi.");
      } else {
        await createCustomerMail(payload);
        showFeedback("success", "Mail kaydi eklendi.");
      }

      resetMailForm();
      await loadCustomerMails();
    } catch (err) {
      console.error("Mail kayit hatasi:", err);
      showFeedback(
        "danger",
        err?.response?.data?.message || "Mail kaydi islenirken hata olustu."
      );
    }
  };

  const handleDeleteMail = async (id) => {
    const confirmDelete = window.confirm("Bu mail kaydi silinsin mi?");
    if (!confirmDelete) return;

    try {
      await deleteCustomerMail(id);
      showFeedback("success", "Mail kaydi silindi.");

      if (editingMailId === id) {
        resetMailForm();
      }

      await loadCustomerMails();
    } catch (err) {
      console.error("Mail silme hatasi:", err);
      showFeedback("danger", "Mail kaydi silinirken hata olustu.");
    }
  };

  const handleSendMail = async () => {
    if (!resData || !resData.data || Object.keys(resData.data).length === 0) {
      showFeedback("danger", "Gonderilecek veri bulunamadi.");
      return;
    }

    if (!selectedEmails.length) {
      showFeedback("danger", "Lutfen en az bir alici secin.");
      return;
    }

    setMailSending(true);
    setSendResultMap({});

    try {
      const emailText = selectedEmails.join(",");
      const response = await sendStockMailFormat(emailText, resData.data);

      // API bazen axios response döner, bazen direkt data döner.
      // İkisini de destekliyoruz.
      const payload = response?.data || response;

      console.log("Mail API response:", payload);

      const resultList = Array.isArray(payload?.data) ? payload.data : [];

      const resultMap = {};
      resultList.forEach((item) => {
        resultMap[String(item.email).trim().toLowerCase()] = {
          status: item.status || "queued",
          errorMessage: item.errorMessage || "",
        };
      });

      setSendResultMap(resultMap);

      if (payload && payload.success) {
        const summary = payload.summary || {};

        showFeedback(
          "success",
          `Mail gonderimi baslatildi. Kuyruga alinan: ${
            summary.queued || summary.total || selectedEmails.length
          }`
        );
      } else {
        showFeedback(
          "danger",
          payload?.message || "Mail gonderimi baslatilamadi."
        );
      }
    } catch (err) {
      console.error("Mail gonderim hatasi:", err);

      showFeedback(
        "danger",
        err?.response?.data?.message ||
          err?.message ||
          "Mail gonderilirken sunucu tarafinda bir hata olustu."
      );
    } finally {
      setMailSending(false);
    }
  };
  const handleExportExcel = () => {
    if (!resData || !resData.data) return;

    const { CR = [], GR = [], HR = [] } = resData.data;

    if (CR.length === 0 && GR.length === 0 && HR.length === 0) {
      showFeedback("danger", "Dışa aktarılacak veri bulunamadı.");
      return;
    }

    const workbook = XLSX.utils.book_new();

    // --- YARDIMCI SIRALAMA FONKSİYONU (Maildekiyle Aynı) ---
    const sortStockData = (data) => {
      return [...data].sort((a, b) => {
        const ebatA = a.EBAT || "-";
        const ebatB = b.EBAT || "-";
        if (ebatA === ebatB) return (a.KALINLIK || 0) - (b.KALINLIK || 0);
        return ebatA.localeCompare(ebatB, undefined, { numeric: true });
      });
    };

    // 1. SAYFA: MATRİS (PIVOT) - Öncekiyle aynı mantık
    const allEbatSet = new Set();
    const crKalinlikSet = new Set();
    const grKalinlikSet = new Set();
    const hrKalinlikSet = new Set();

    CR.forEach((i) => {
      allEbatSet.add(i.EBAT || "-");
      crKalinlikSet.add(i.KALINLIK || 0);
    });
    GR.forEach((i) => {
      allEbatSet.add(i.EBAT || "-");
      grKalinlikSet.add(i.KALINLIK || 0);
    });
    HR.forEach((i) => {
      allEbatSet.add(i.EBAT || "-");
      hrKalinlikSet.add(i.KALINLIK || 0);
    });

    const sortedEbatlar = Array.from(allEbatSet).sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true })
    );
    const crKalinliklar = Array.from(crKalinlikSet).sort((a, b) => a - b);
    const grKalinliklar = Array.from(grKalinlikSet).sort((a, b) => a - b);
    const hrKalinliklar = Array.from(hrKalinlikSet).sort((a, b) => a - b);

    const matrixAoA = [
      ["GÖKTAŞ SERBEST STOK ÜRÜN MATRİSİ"],
      [
        "EBAT \\ KALINLIK",
        ...crKalinliklar.map(() => "SOĞUK (CR)"),
        ...grKalinliklar.map(() => "GALVANİZ (GR)"),
        ...hrKalinliklar.map(() => "SICAK (HR)"),
      ],
      ["", ...crKalinliklar, ...grKalinliklar, ...hrKalinliklar],
    ];

    sortedEbatlar.forEach((ebat) => {
      const row = [ebat];
      crKalinliklar.forEach((k) =>
        row.push(
          CR.some((i) => (i.EBAT || "-") === ebat && (i.KALINLIK || 0) === k)
            ? "X"
            : ""
        )
      );
      grKalinliklar.forEach((k) =>
        row.push(
          GR.some((i) => (i.EBAT || "-") === ebat && (i.KALINLIK || 0) === k)
            ? "X"
            : ""
        )
      );
      hrKalinliklar.forEach((k) =>
        row.push(
          HR.some((i) => (i.EBAT || "-") === ebat && (i.KALINLIK || 0) === k)
            ? "X"
            : ""
        )
      );
      matrixAoA.push(row);
    });

    const matrixSheet = XLSX.utils.aoa_to_sheet(matrixAoA);
    XLSX.utils.book_append_sheet(workbook, matrixSheet, "Stok Matrisi");

    // 2. SAYFA: DETAYLI TABLOLAR (Tablo Tablo Alt Alta)
    const detailAoA = [];
    const headers = ["EBAT", "KALINLIK", "UZUNLUK", "TOPLAM ADET", "KG"];

    // --- SOĞUK (CR) TABLOSU ---
    if (CR.length > 0) {
      detailAoA.push(["GÖKTAŞ SOĞUK (CR) SERBEST STOK"]); // Tablo Başlığı
      detailAoA.push(headers); // Sütun Başlıkları

      const sortedCR = sortStockData(CR);
      sortedCR.forEach((item) => {
        detailAoA.push([
          item.EBAT || "-",
          item.KALINLIK || 0,
          item.BOY || "-",
          Number(item.PAKETİÇİADET || 0),
          Number(item.KG || 0),
        ]);
      });
    }

    // Tablolar arasına 2 boş satır
    detailAoA.push([]);
    detailAoA.push([]);

    // --- GALVANİZ (GR) TABLOSU ---
    if (GR.length > 0) {
      detailAoA.push(["GÖKTAŞ GALVANİZ (GR) SERBEST STOK"]); // Tablo Başlığı
      detailAoA.push(headers); // Sütun Başlıkları

      const sortedGR = sortStockData(GR);
      sortedGR.forEach((item) => {
        detailAoA.push([
          item.EBAT || "-",
          item.KALINLIK || 0,
          item.BOY || "-",
          Number(item.PAKETİÇİADET || 0),
          Number(item.KG || 0),
        ]);
      });
    }

    // Tablolar arasına 2 boş satır
    detailAoA.push([]);
    detailAoA.push([]);

    // --- SICAK (HR) TABLOSU ---
    if (HR.length > 0) {
      detailAoA.push(["GÖKTAŞ SICAK (HR) SERBEST STOK"]); // Tablo Başlığı
      detailAoA.push(headers); // Sütun Başlıkları

      const sortedHR = sortStockData(HR);
      sortedHR.forEach((item) => {
        detailAoA.push([
          item.EBAT || "-",
          item.KALINLIK || 0,
          item.BOY || "-",
          Number(item.PAKETİÇİADET || 0),
          Number(item.KG || 0),
        ]);
      });
    }

    const detailSheet = XLSX.utils.aoa_to_sheet(detailAoA);

    // Görsel Düzenleme: Kolon genişliklerini ayarla
    detailSheet["!cols"] = [
      { wch: 18 }, // Ebat
      { wch: 10 }, // Kalınlık
      { wch: 10 }, // Uzunluk
      { wch: 15 }, // Adet
      { wch: 12 }, // Kg
    ];

    XLSX.utils.book_append_sheet(workbook, detailSheet, "Detaylı Stok Listesi");

    // DOSYAYI İNDİR
    const dateStr = new Date().toLocaleDateString("tr-TR").replace(/\./g, "_");
    XLSX.writeFile(workbook, `Goktas_Stok_Detayli_${dateStr}.xlsx`);
  };
  const renderSendStatus = (email) => {
    const key = String(email || "")
      .trim()
      .toLowerCase();
    const result = sendResultMap[key];

    if (mailSending && selectedEmails.includes(email)) {
      return (
        <Badge bg="warning" text="dark">
          Bekliyor
        </Badge>
      );
    }

    if (!result) {
      return <span className="text-muted small">-</span>;
    }
    if (result.status === "queued") {
      return (
        <Badge bg="warning" text="dark">
          Kuyrukta
        </Badge>
      );
    }
    if (result.status === "sent") {
      return <Badge bg="success">Gönderildi</Badge>;
    }

    return (
      <Badge bg="danger" title={result.errorMessage || "Mail gönderilemedi"}>
        Hata
      </Badge>
    );
  };

  return (
    <Layout>
      <h2 className="fw-bold mb-4">Profil/Boru Stok ve Mail Formati Alimi</h2>

      <Card className="p-4 mb-4 shadow-sm border-0">
        <Row className="align-items-end g-3">
          <Col md={8}>
            <Form.Group>
              <Form.Label className="fw-semibold">
                Satis Stok Excel Dosyasi
              </Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileChange}
              />
            </Form.Group>
          </Col>

          <Col md={4} className="text-end">
            <Button
              variant="primary"
              onClick={handleUpload}
              disabled={loading || !file}
              className="w-100"
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Isleniyor...
                </>
              ) : (
                "Dosyayi Yukle ve Olustur"
              )}
            </Button>
          </Col>
        </Row>
      </Card>

      {resData && resData.data && (
        <>
          <Row className="mb-4 g-3">
            <Col md={3}>
              <Card className="bg-secondary text-white shadow-sm h-100 border-0">
                <Card.Body>
                  <h6 className="text-uppercase mb-2 opacity-75">
                    Soguk (CR) Toplam
                  </h6>
                  <h3 className="mb-0">
                    {crTotalKg.toLocaleString("tr-TR")}{" "}
                    <small className="fs-6">KG</small>
                  </h3>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="bg-primary text-white shadow-sm h-100 border-0">
                <Card.Body>
                  <h6 className="text-uppercase mb-2 opacity-75">
                    Galvaniz (GR) Toplam
                  </h6>
                  <h3 className="mb-0">
                    {grTotalKg.toLocaleString("tr-TR")}{" "}
                    <small className="fs-6">KG</small>
                  </h3>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="bg-warning text-dark shadow-sm h-100 border-0">
                <Card.Body>
                  <h6 className="text-uppercase mb-2 opacity-75">
                    Sıcak (HR) Toplam
                  </h6>
                  <h3 className="mb-0">
                    {hrTotalKg.toLocaleString("tr-TR")}{" "}
                    <small className="fs-6">KG</small>
                  </h3>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="bg-success text-white shadow-sm h-100 border-0">
                <Card.Body>
                  <h6 className="text-uppercase mb-2 opacity-75">
                    Genel Toplam
                  </h6>
                  <h3 className="mb-0 fw-bold">
                    {genelTotalKg.toLocaleString("tr-TR")}{" "}
                    <small className="fs-6">KG</small>
                  </h3>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Card className="shadow-sm border-0 p-4">
            <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-4">
              <h4 className="fw-bold text-dark mb-0">
                Mail Gonderim Onizlemesi
              </h4>

              <div className="d-flex gap-2">
                <Button
                  variant="outline-secondary"
                  onClick={handleExportExcel}
                  disabled={Object.keys(resData.data).length === 0}
                >
                  Excel'e Aktar
                </Button>

                <Button
                  variant="success"
                  onClick={() => setShowMailModal(true)}
                  disabled={Object.keys(resData.data).length === 0}
                >
                  Mail Alicilarini Yonet ve Gonder
                </Button>
              </div>
            </div>

            {Object.keys(resData.data).length === 0 ? (
              <div className="text-center text-muted py-5">
                Listede gonderilecek kayit kalmadi.
              </div>
            ) : (
              <>
                <div className="mb-5 border border-2 border-secondary rounded p-3 bg-light">
                  <h5 className="fw-bold mb-3 text-dark d-flex align-items-center">
                    GÖKTAŞ SERBEST STOK ÜRÜN MATRİSİ
                  </h5>

                  <p className="text-muted small mb-3">
                    Aşağıdaki tablodaki kırmızı <strong>"X"</strong> butonlarına
                    basarak, o ebat ve kalınlıktaki tüm kayıtları tek seferde
                    silebilirsiniz.
                  </p>

                  <div className="table-responsive">
                    <Table
                      bordered
                      hover
                      size="sm"
                      className="bg-white text-center align-middle mb-0"
                      style={{ fontSize: "13px" }}
                    >
                      <thead>
                        <tr>
                          <th
                            rowSpan="2"
                            className="align-middle bg-light"
                            style={{ width: "120px" }}
                          >
                            EBAT \ KALINLIK
                          </th>

                          {crKalinliklar.length > 0 && (
                            <th
                              colSpan={crKalinliklar.length}
                              className="bg-secondary text-white"
                              style={{ letterSpacing: "1px" }}
                            >
                              SOĞUK (CR)
                            </th>
                          )}

                          {grKalinliklar.length > 0 && (
                            <th
                              colSpan={grKalinliklar.length}
                              style={{
                                backgroundColor: "#455a64",
                                color: "#fff",
                                borderLeft: "3px solid #333",
                                letterSpacing: "1px",
                              }}
                            >
                              GALVANİZ (GR)
                            </th>
                          )}

                          {hrKalinliklar.length > 0 && (
                            <th
                              colSpan={hrKalinliklar.length}
                              style={{
                                backgroundColor: "#e65100",
                                color: "#fff",
                                borderLeft: "3px solid #bf360c",
                                letterSpacing: "1px",
                              }}
                            >
                              SICAK (HR)
                            </th>
                          )}
                        </tr>

                        <tr>
                          {crKalinliklar.map((k) => (
                            <th
                              key={`cr-head-${k}`}
                              style={{
                                backgroundColor: "#e6f0fa",
                                color: "#003366",
                                width: "40px",
                              }}
                            >
                              {k}
                            </th>
                          ))}

                          {grKalinliklar.map((k, idx) => (
                            <th
                              key={`gr-head-${k}`}
                              style={{
                                backgroundColor: "#cfd8dc",
                                color: "#333",
                                width: "40px",
                                borderLeft: idx === 0 ? "3px solid #333" : "",
                              }}
                            >
                              {k}
                            </th>
                          ))}

                          {hrKalinliklar.map((k, idx) => (
                            <th
                              key={`hr-head-${k}`}
                              style={{
                                backgroundColor: "#ffe0b2",
                                color: "#7f2704",
                                width: "40px",
                                borderLeft:
                                  idx === 0 ? "3px solid #bf360c" : "",
                              }}
                            >
                              {k}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {sortedEbatlar.map((ebat) => (
                          <tr key={ebat}>
                            <td className="text-start fw-bold bg-light">
                              {ebat}
                            </td>

                            {crKalinliklar.map((k) => {
                              const exists = crItems.some(
                                (i) =>
                                  (i.EBAT || "-") === ebat &&
                                  (i.KALINLIK || 0) === k
                              );

                              return (
                                <td key={`cr-cell-${ebat}-${k}`}>
                                  {exists && (
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      className="fw-bold py-0 px-2"
                                      title={`${ebat} ${k} Soğuk ürünlerini sil`}
                                      onClick={() =>
                                        handleRemoveFromMatrix("CR", ebat, k)
                                      }
                                    >
                                      X
                                    </Button>
                                  )}
                                </td>
                              );
                            })}

                            {grKalinliklar.map((k, idx) => {
                              const exists = grItems.some(
                                (i) =>
                                  (i.EBAT || "-") === ebat &&
                                  (i.KALINLIK || 0) === k
                              );

                              return (
                                <td
                                  key={`gr-cell-${ebat}-${k}`}
                                  style={
                                    idx === 0
                                      ? { borderLeft: "3px solid #333" }
                                      : {}
                                  }
                                >
                                  {exists && (
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      className="fw-bold py-0 px-2"
                                      title={`${ebat} ${k} Galvaniz ürünlerini sil`}
                                      onClick={() =>
                                        handleRemoveFromMatrix("GR", ebat, k)
                                      }
                                    >
                                      X
                                    </Button>
                                  )}
                                </td>
                              );
                            })}

                            {hrKalinliklar.map((k, idx) => {
                              const exists = hrItems.some(
                                (i) =>
                                  (i.EBAT || "-") === ebat &&
                                  (i.KALINLIK || 0) === k
                              );

                              return (
                                <td
                                  key={`hr-cell-${ebat}-${k}`}
                                  style={
                                    idx === 0
                                      ? { borderLeft: "3px solid #bf360c" }
                                      : {}
                                  }
                                >
                                  {exists && (
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      className="fw-bold py-0 px-2"
                                      title={`${ebat} ${k} Sıcak ürünlerini sil`}
                                      onClick={() =>
                                        handleRemoveFromMatrix("HR", ebat, k)
                                      }
                                    >
                                      X
                                    </Button>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>

                {["CR", "GR", "HR"].map((groupKey) => {
                  if (
                    !resData.data[groupKey] ||
                    resData.data[groupKey].length === 0
                  ) {
                    return null;
                  }

                  const anlasilirTurAdi = turIsimleri[groupKey] || groupKey;
                  const badgeColor =
                    groupKey === "CR"
                      ? "secondary"
                      : groupKey === "GR"
                        ? "primary"
                        : "warning";

                  return (
                    <div key={groupKey} className="mb-5">
                      <h5 className="fw-bold mb-3 d-flex align-items-center text-dark">
                        <Badge bg={badgeColor} className="me-2 fs-6">
                          {anlasilirTurAdi} ({groupKey})
                        </Badge>
                        Detay Listesi
                      </h5>

                      <Table
                        hover
                        responsive
                        bordered
                        className="align-middle bg-white text-sm"
                      >
                        <thead className="table-light">
                          <tr>
                            <th
                              style={{ width: "50px" }}
                              className="text-center"
                            >
                              İşlem
                            </th>
                            <th>Ebat</th>
                            <th>Kalınlık</th>
                            <th>Uzunluk</th>
                            <th className="text-end">Toplam Adet</th>
                            <th className="text-end">Miktar (Kg)</th>
                          </tr>
                        </thead>

                        <tbody>
                          {resData.data[groupKey].map((item, index) => (
                            <tr key={index}>
                              <td className="text-center">
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  className="fw-bold px-2 py-0"
                                  onClick={() =>
                                    handleRemoveItem(groupKey, index)
                                  }
                                >
                                  -
                                </Button>
                              </td>

                              <td className="fw-bold">{item.EBAT || "-"}</td>
                              <td>{item.KALINLIK || "0"}</td>
                              <td>{item.BOY || "-"}</td>

                              <td className="text-end">
                                {Number(item.PAKETİÇİADET || 0).toLocaleString(
                                  "tr-TR"
                                )}
                              </td>

                              <td className="text-end fw-semibold text-primary">
                                {Number(item.KG || 0).toLocaleString("tr-TR")}{" "}
                                kg
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  );
                })}
              </>
            )}

            <div className="mt-2 text-muted small border-top pt-3">
              <p className="mb-1">
                İstenmeyen satırları yanındaki eksi (-) veya matristeki kırmızı
                (X) butonlarına basarak çıkarabilirsiniz. Sildiğiniz satırlar
                yukarıdaki toplamlardan da otomatik düşer ve maile dahil
                edilmez. Ayrıca Excel'e aktarılırken de silinmiş halleriyle
                aktarılır.
              </p>
              <p>Oluşturulma Tarihi: {new Date().toLocaleString("tr-TR")}</p>
            </div>
          </Card>
        </>
      )}

      <Modal show={showMailModal} onHide={closeMailModal} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Mail Alicilarini Yonet ve Gonder</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className="g-4">
            <Col md={4}>
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <h5 className="fw-bold mb-3">
                    {mailFormMode === "update"
                      ? "Mail Kaydini Guncelle"
                      : "Yeni Mail Ekle"}
                  </h5>

                  <Form.Group className="mb-2">
                    <Form.Label>Firma</Form.Label>
                    <Form.Control
                      value={mailForm.companyName}
                      onChange={(e) =>
                        setMailForm({
                          ...mailForm,
                          companyName: e.target.value,
                        })
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Yetkili</Form.Label>
                    <Form.Control
                      value={mailForm.contactName}
                      onChange={(e) =>
                        setMailForm({
                          ...mailForm,
                          contactName: e.target.value,
                        })
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Mail</Form.Label>
                    <Form.Control
                      type="email"
                      value={mailForm.email}
                      onChange={(e) =>
                        setMailForm({ ...mailForm, email: e.target.value })
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Telefon</Form.Label>
                    <Form.Control
                      type="text"
                      value={mailForm.phone}
                      onChange={(e) =>
                        setMailForm({ ...mailForm, phone: e.target.value })
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Departman</Form.Label>
                    <Form.Control
                      value={mailForm.department}
                      onChange={(e) =>
                        setMailForm({ ...mailForm, department: e.target.value })
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Etiketler</Form.Label>
                    <Form.Control
                      value={mailForm.tagsText}
                      onChange={(e) =>
                        setMailForm({ ...mailForm, tagsText: e.target.value })
                      }
                      placeholder="rulo-stok, aktif-musteri"
                    />
                    <Form.Text className="text-muted">
                      Birden fazla etiketi virgulle ayir.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Not</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={mailForm.note}
                      onChange={(e) =>
                        setMailForm({ ...mailForm, note: e.target.value })
                      }
                    />
                  </Form.Group>

                  <Form.Check
                    className="mb-3"
                    type="switch"
                    label="Mail izni aktif"
                    checked={mailForm.mailPermission}
                    onChange={(e) =>
                      setMailForm({
                        ...mailForm,
                        mailPermission: e.target.checked,
                      })
                    }
                  />

                  <div className="d-flex gap-2">
                    <Button variant="primary" onClick={handleSaveMail}>
                      {mailFormMode === "update" ? "Guncelle" : "Ekle"}
                    </Button>

                    {mailFormMode === "update" && (
                      <Button variant="secondary" onClick={resetMailForm}>
                        Vazgec
                      </Button>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col md={8}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <h5 className="fw-bold mb-1">Sistemdeki Mail Listesi</h5>
                  <div className="text-muted small">
                    Seçili alıcı sayısı: {selectedEmails.length}
                  </div>
                </div>

                <InputGroup style={{ maxWidth: "360px" }}>
                  <Form.Control
                    placeholder="Firma, yetkili veya mail ara"
                    value={mailSearch}
                    onChange={(e) => setMailSearch(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        loadCustomerMails();
                      }
                    }}
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={loadCustomerMails}
                  >
                    Ara
                  </Button>
                </InputGroup>
              </div>

              <div className="table-responsive" style={{ maxHeight: "520px" }}>
                <Table bordered hover size="sm" className="align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "50px" }} className="text-center">
                        <Form.Check
                          checked={
                            mailList.length > 0 &&
                            selectedEmails.length ===
                              mailList.filter((x) => x.mailPermission !== false)
                                .length
                          }
                          onChange={handleToggleAllEmails}
                        />
                      </th>
                      <th>Firma</th>
                      <th>Yetkili</th>
                      <th>Mail</th>
                      <th>Etiket</th>
                      <th>Durum</th>
                      <th style={{ width: "110px" }}>Gönderim</th>
                      <th style={{ width: "120px" }}>İşlem</th>
                    </tr>
                  </thead>

                  <tbody>
                    {mailListLoading ? (
                      <tr>
                        <td colSpan="8" className="text-center py-4">
                          <Spinner
                            animation="border"
                            size="sm"
                            className="me-2"
                          />
                          Yukleniyor...
                        </td>
                      </tr>
                    ) : mailList.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center text-muted py-4">
                          Mail kaydi bulunamadi.
                        </td>
                      </tr>
                    ) : (
                      mailList.map((item) => {
                        const disabled = item.mailPermission === false;

                        return (
                          <tr key={item._id}>
                            <td className="text-center">
                              <Form.Check
                                disabled={disabled}
                                checked={selectedEmails.includes(item.email)}
                                onChange={() => handleToggleEmail(item.email)}
                              />
                            </td>

                            <td>{item.companyName || "-"}</td>
                            <td>{item.contactName || "-"}</td>
                            <td className="fw-semibold">{item.email}</td>

                            <td>
                              {Array.isArray(item.tags) && item.tags.length > 0
                                ? item.tags.map((tag) => (
                                    <Badge
                                      bg="secondary"
                                      className="me-1"
                                      key={tag}
                                    >
                                      {tag}
                                    </Badge>
                                  ))
                                : "-"}
                            </td>

                            <td>
                              {item.mailPermission === false ? (
                                <Badge bg="danger">Kapali</Badge>
                              ) : (
                                <Badge bg="success">Aktif</Badge>
                              )}
                            </td>

                            <td>{renderSendStatus(item.email)}</td>

                            <td>
                              <div className="d-flex gap-1">
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  onClick={() => handleEditMail(item)}
                                >
                                  Duzenle
                                </Button>

                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() => handleDeleteMail(item._id)}
                                >
                                  Sil
                                </Button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={closeMailModal}
            disabled={mailSending}
          >
            Kapat
          </Button>

          <Button
            variant="success"
            onClick={handleSendMail}
            disabled={mailSending || selectedEmails.length === 0}
          >
            {mailSending ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Gonderiliyor...
              </>
            ) : (
              `Secili ${selectedEmails.length} Aliciya Mail Gonder`
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={feedback.show}
        onHide={() => setFeedback({ ...feedback, show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {feedback.type === "success" ? "İşlem Başarılı" : "Uyarı / Hata"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-0">{feedback.message}</p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant={feedback.type === "success" ? "primary" : "secondary"}
            onClick={() => setFeedback({ ...feedback, show: false })}
          >
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}

export default RuloStokSatisGiris;
